module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_is-object.js
// module id = 174
// module chunks = 0